import type { GroupLayout } from "~/js/graph/node-layout";
import type { GraphNode } from "~/js/graph/node-socket-connection";
import type { NodeDefinition } from "~/js/nodes/node-definition";
import { getPrivateMessageFromError } from "~/solidJs/shared/helpers";
import EventAnalytics from "./EventAnalytics";

/**
 * @description sets executor function to new function, passes the original executor function as an argument to new function, on error in new function call the old one as a fallback
 * @param definition definition in what we need to swap the executor function
 * @param newExecutor new executor function that we need to call on node execution
 */
export const changeNodeExecutorOnCustom = (
	definition: NodeDefinition,
	newExecutor: nodeNewExecutor
) => {
	const initialExecutor = definition.initExecutionGroup as (...args: any) => void;
	definition.initExecutionGroup = (node: GraphNode, layout: GroupLayout) => {
		try {
			newExecutor(node, layout, initialExecutor);
		} catch (e) {
			console.log(e, definition?.globalId);
			EventAnalytics.sendErrorInfo("custom-executor-error-fc", {
				message: getPrivateMessageFromError(e) || "custom-executor-error-fc",
				globalId: definition?.globalId
			});
			initialExecutor.call(definition, node, layout);
		}
	};
};
export type nodeExecutor = (node: GraphNode, layout: GroupLayout) => void;
export type nodeNewExecutor = (
	node: GraphNode,
	layout: GroupLayout,
	initialExecutor: nodeExecutor
) => void;
